/**
 * Created by pajicv on 10/4/18.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import CyclesContainer from './CyclesContainer';
import { spinnerWhileLoading } from '../../utils/components';

const enhance = compose(
    connect(
        (state, props) => {
            const { location: { state: { projectId } }, history } = props;
            const cycles = state.firebase.data.projects ? state.firebase.data.projects[projectId].cycles : undefined;
            const project = state.firebase.data.projects ? state.firebase.data.projects[projectId] : undefined;
            return ({
                cycles,
                project,
                projectId,
                history,
                auth: state.firebase.auth
            });
        }
    ),
    firebaseConnect((props) => {
        const { location: { state: { projectId } } } = props;
        return [{ path: `projects/${projectId}/cycles`, queryParams: [`orderByChild=index`] }, { path: `projects/${projectId}`, queryParams: [`orderByKey`] }];
    }),
    spinnerWhileLoading(['cycles', 'project'])
);

export default enhance(CyclesContainer);



// WEBPACK FOOTER //
// ./src/components/Cycles/CyclesContainer.enhancer.js